import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  HistoricInstalls,
  Machine,
  MachineUnites,
} from 'src/app/model/machine/machine.model';
import { WebConfigurationService } from '../common/web-configuration.service';

@Injectable({
  providedIn: 'root',
})
export class MachineService extends WebConfigurationService {
  constructor(protected http: HttpClient) {
    super(http);
  }
  /**
   * Get one machine
   * @param id  the id of the machine
   * @returns an Observable
   */
  public getMachine(id: string): Observable<Machine> {
    return this.authGetObs<Machine>(this.getMachineUrl(id));
  }

  /**
   * Get one machine materiel unites
   * @param id  the id of the machine
   * @returns an Observable
   */
  public getMaterielUnite(id: string): Observable<MachineUnites> {
    return this.authGetObs<MachineUnites>(this.getMaterielUniteUrl(id));
  }

  /**
   * Get one machine historic installations
   * @param id  the id of the machine
   * @returns an Observable
   */
  public getHistoInstall(id: string): Observable<HistoricInstalls> {
    return this.authGetObs<HistoricInstalls>(this.getHistoInstallUrl(id));
  }
}
